import { createContext, useContext } from "react"

import { useRepositoryLocalesQuery } from "../settings/locales/useRepositoryLocales"
import type { DocumentListSearchParamsContextType } from "./DocumentListSearchParamsProvider"

export const DocumentListSearchParamsContext = createContext<
  DocumentListSearchParamsContextType | undefined
>(undefined)

export function useDocumentListSearchParams() {
  const searchParamsContext = useContext(DocumentListSearchParamsContext)

  if (!searchParamsContext)
    throw new Error(
      "useDocumentListSearchParams must be called from within the DocumentListSearchParamsProvider",
    )

  return searchParamsContext
}

export function useRepositoryLanguages() {
  const { data: langs } = useRepositoryLocalesQuery()

  const masterLocale = langs.find((language) => language.isMaster)

  if (!masterLocale) throw new Error("Cannot find a master locale.")

  return { masterLocaleId: masterLocale.id, langs }
}
